
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  for(var i = 0;i < items.length;i++){ 
    ; __append("\n<div class=\"mod-box\" data-mid=\"")
    ; __append(escape(items[i].mid))
    ; __append("\">\n\n    ")
    ;  if (items[i].dateStr && !items[i].isTop){ 
    ; __append("\n    <div class=\"mod-lineTitle\">\n        <h4 class=\"title\">")
    ; __append(escape(items[i].dateStr))
    ; __append("</h4>\n    </div>\n    ")
    ;  } 
    ; __append("\n\n    <div class=\"mod-news-block clearfix\">\n\n\n        <div class=\"mod-news-time clearfix\">\n            ")
    ;  if(items[i].isAd){ 
    ; __append("\n            <div class=\"time fr ad_title\">")
    ; __append(escape(items[i].covertime))
    ; __append("</div>\n            ")
    ;  }else{ 
    ; __append("\n                 ")
    ;  if(items[i].isTop) { 
    ; __append("\n            <span class=\"icon-top\"></span>\n                ")
    ; }
    ; __append("\n            ")
    ;  if(!items[i].isTop) { 
    ; __append("\n            <span class=\"time fr\">")
    ; __append(escape(items[i].covertime))
    ; __append("</span>\n            ")
    ;  }} 
    ; __append("\n            ")
    ;  if (items[i].user_image){ 
    ; __append("\n            ")
    ;  if (items[i].user_url){ 
    ; __append("\n            <a href=\"")
    ; __append(escape(items[i].user_url))
    ; __append("\" target=\"_blank\" class=\"link\">\n                <img class=\"avatar\" src=\"")
    ; __append(escape(items[i].user_image))
    ; __append("\" alt=\"用户\">\n                <span class=\"ava-mask\"></span>\n            </a>\n            ")
    ;  }else{ 
    ; __append("\n            <span class=\"link fl\">\n                            <img class=\"avatar\" src=\"")
    ; __append(escape(items[i].user_image))
    ; __append("\" alt=\"用户\">\n                    <span class=\"ava-mask\"></span>\n                </span>\n            ")
    ;  } 
    ; __append("\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (items[i].user_url){ 
    ; __append("\n            <a href=\"")
    ;  items[i].user_url 
    ; __append("\" target=\"_blank\" class=\"name-s\">\n                ")
    ;  items[i].user 
    ; __append("\n            </a>\n            ")
    ;  }else{ 
    ; __append("\n            <span class=\"name-s\">")
    ; __append(escape(items[i].user))
    ; __append("</span>\n            ")
    ;  } 
    ; __append("\n\n        </div>\n        ")
    ; (function(){
    ; __append("<div class=\"mod-news-content\">\n\n    <div class=\"news-con\">\n        ")
    ;  if (items[i].title){
    ; __append("\n        <h3 class=\"news-title\">\n            ")
    ;  if (items[i].title_link){
    ; __append("\n            <a href=\"")
    ; __append(escape(items[i].title_link))
    ; __append("\" target=\"_blank\">")
    ; __append(escape(items[i].title))
    ; __append("</a>\n            ")
    ; }else{
    ; __append("\n            <span>")
    ; __append(escape(items[i].title))
    ; __append("</span>\n            ")
    ; }
    ; __append("\n        </h3>\n        ")
    ; }
    ; __append("\n\n\n\n        ")
    ;  if (items[i].abstract1){
    ; __append("\n        <div class=\"info\">\n            ")
    ;  if (items[i].hasContent){
    ; __append("\n            ")
    ; __append(escape(items[i].abstract1))
    ; __append("\n            ")
    ;  if (items[i].abstract_link){
    ; __append("<span class=\"detail_url stress\" data-link=\" ")
    ; __append(escape(items[i].abstract_link))
    ; __append("\">[详细]</span>")
    ; }
    ; __append("\n            ")
    ; }
    ; __append("\n        </div>\n        ")
    ; }
    ; __append("\n\n    </div>\n\n</div>\n\n")
    ; }).call(this)
    ; __append("\n    </div>\n\n    <div class=\"border-line\"></div>\n\n\n</div>\n\n")
    ;  } 
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.pagelist.mobile/app/modules/view/newsItem.ejs
// module id = 406
// module chunks = 0